import EventsHelper from '../../_helpers/events';
import $ from 'jquery'

export default class MatchDataCollector {

  channelLoaded = false;

  matchLiveStatus = {
    DEFAULT: -1,
    Start: 4,
    End: 24
  }

  constructor() {
    let _this = this;

    if (!window.matchconfig) {
      return;
    }


    if (_this.isMatchPage() && _this.isMatchLive()) {
      _this.loadChannels();
    } else if (_this.isBeforeMatchDay()) {
      EventsHelper.BeforeMatchDay();
    } else if (_this.isAfterMatchDay()) {
      EventsHelper.AfterMatchDay();
    } else if (window.matchconfig.matchdate) {
      _this.loadChannels();
    }

    if (window.matchconfig.matchlistpollingenabled && !_this.channelLoaded) {
      _this.loadMatchListDataUpdateChannel();
    }

    EventsHelper.OnAjaxModuleLoaded(function () {
      let firstLoadChannel = window.matchconfig.channels.filter(c => c.needFirstCall && c.eventname === 'MatchListDataUpdate');
      for (let ch of firstLoadChannel) {
        _this.callChannel(ch);
      }
    });

  }

  loadChannels() {
    let _this = this;
    let channels = window.matchconfig.channels;
    if (!channels?.length) { return; }

    for (let ch of channels) {
      if (ch.eventname && ch.url && ch.pollingtime) {
        if (ch.needFirstCall) {
          _this.callChannel(ch);
        }

        setInterval(function () {
          _this.callChannel(ch);
        }, ch.pollingtime);
      }
    }
    _this.channelLoaded = true;
  }

  loadMatchListDataUpdateChannel() {
    let _this = this;

    let ch = window.matchconfig.channels.filter(c => c.eventname === 'MatchListDataUpdate');

    if (ch.length) {
      ch = ch[0];
    }

    if (ch.url && ch.pollingtime) {
      if (ch.needFirstCall) {
        _this.callChannel(ch);
      }

      setInterval(function () {
        _this.callChannel(ch);
      }, ch.pollingtime);
    }
  }

  callChannel(ch) {
    $.ajax({
      url: ch.url,
    }).done(function (data) {
      EventsHelper.Trigger(ch.eventname, data);
    });
  }

  isMatchPage() {
    return $(".vbw-match-header-wrapper")?.length > 0 && window.matchconfig?.match > 0;
  }

  isMatchLive() {
    let currentStatus = window.matchconfig?.status;
    let _this = this;
    return currentStatus > _this.matchLiveStatus.Start && currentStatus < _this.matchLiveStatus.End
  }

  isBeforeMatchDay(forcedDate) {
    let _this = this;
    let matchdate = new Date(Date.parse(window.matchconfig.matchdate));
    let today = forcedDate || new Date();
    matchdate = _this.flattenDate(matchdate);
    today = _this.flattenDate(today);

    return (today < matchdate);
  }

  isAfterMatchDay(forcedDate) {
    let _this = this;
    let matchdate = new Date(Date.parse(window.matchconfig.matchdate));
    let today = forcedDate || new Date();

    matchdate = _this.flattenDate(matchdate);
    today = _this.flattenDate(today);

    return (today > matchdate);
  }

  flattenDate(date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    return date;
  }


}

